import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { icons } from '../../../../constants'
import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import LtsCurrency from '../../../../components/lottus/lts-currency'

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function ReajustarLancamentoDialog(props) {
  const [valor, setValor] = useState(0)

  useEffect(() => {
    resetValues()
  }, [props.visible])

  const isConfirmarDisabled = () => {
    return valor === 0
  }

  const onHide = () => {
    props.onHide()
  }

  const onConfirm = () => {
    props.onConfirm({
      valor,
      lancamentos: _.get(props, 'lancamentosReajustar', []),
    })
    onHide()
  }

  const resetValues = () => {
    setValor(0)
  }

  return (
    <Dialog
      header={_.defaultTo(props.title, 'Reajustar Lançamento')}
      visible={props.visible}
      style={{ width: '30vw' }}
      onHide={() => {
        onHide()
      }}
      baseZIndex={1000000}
      modal={true}
      closable={true}
    >
      <div style={{ marginTop: '20px' }} className="p-grid p-fluid">
        <div className="form-group p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
          <LtsCurrency
            mode={'decimal'}
            value={valor}
            name={'percentualReajuste'}
            label={_.defaultTo(props.labelPercentualReajuste, 'Reajuste (%)')}
            onChange={(e) => setValor(e)}
            disabled={props.bloquearLancamento}
          />
        </div>
      </div>
      <div style={{ marginTop: '20px' }} className="p-grid form-group">
        <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
          <Button
            label={_.defaultTo(props.labelConfirmar, 'Confirmar')}
            onClick={() => {
              onConfirm()
            }}
            disabled={isConfirmarDisabled()}
            icon={icons.CHECK_ICON}
            className="p-button-success"
          />
        </div>
      </div>
    </Dialog>
  )
}
